class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', event => { if (event.code === 'Escape') this.close(); });
    this.addEventListener('click', event => { if (event.target.closest('#CartDrawer-Overlay')) this.close(); const removeMix = event.target.closest('[data-cp-remove-mix]'); if (removeMix) window.CandyPeakOwnedCart.removeMixBoxes(removeMix).catch(() => {}); });
    const link = document.getElementById('cart-icon-bubble');
    if (link) {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', event => { event.preventDefault(); window.CandyPeakOwnedCart.open(link).catch(() => {}); });
      link.addEventListener('keydown', event => { if (event.code === 'Space') { event.preventDefault(); window.CandyPeakOwnedCart.open(link).catch(() => {}); } });
    }
  }
  open(trigger) {
    if (trigger) this.setActiveElement(trigger);
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden', 'cp-owned-cart-open');
    requestAnimationFrame(() => this.restoreFocus());
    document.dispatchEvent(new CustomEvent('cp:cart:opened'));
  }
  restoreFocus(target) {
    if (!this.classList.contains('active')) return;
    const container = this.querySelector('.drawer__inner');
    if (container) trapFocus(container, target || this.querySelector('.drawer__close') || container);
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement?.isConnected ? this.activeElement : document.getElementById('cart-icon-bubble'));
    document.body.classList.remove('overflow-hidden', 'cp-owned-cart-open');
  }
  setActiveElement(element) { this.activeElement = element; }
  getSectionsToRender() { return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
  renderContents(response, trigger = this.activeElement, origin, feedbackToken) { return window.CandyPeakOwnedCart.confirmAdd(response, trigger, origin, feedbackToken).catch(() => {}); }
  getSectionInnerHTML(html, selector = '.shopify-section') { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || ''; }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  connectedCallback() {
    this.cartUpdateUnsubscriber?.();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source !== 'cart-items' && !event.cpOwnedCartManaged) this.onCartUpdate();
    });
  }
  onCartUpdate() { window.CandyPeakOwnedCart?.refresh().catch(() => {}); }
  onChange(event) {
    if (!event.target.matches('.quantity__input')) return;
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }
  updateQuantity(line, quantity) {
    const row = this.querySelector(`#CartDrawer-Item-${line}`);
    if (!row) return;
    window.CandyPeakOwnedCart.changeItem(row.dataset.lineKey, Number(quantity));
  }
  getSectionsToRender() { return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }]; }
}
if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  if (window.CandyPeakOwnedCart) return;
  const base = window.Shopify?.routes?.root || '/';
  const depositRecoveryStorageKey = 'cp_drinkbox_deposit_recovery_v1';
  try {
    const saved = JSON.parse(window.sessionStorage?.getItem(depositRecoveryStorageKey) || 'null');
    if (!window.__cpDrinkboxDepositRecoveryPending && saved && typeof saved.boxId === 'string' && saved.boxId && ['deposit', 'bundle'].includes(saved.phase)) {
      window.__cpDrinkboxDepositRecoveryPending = saved;
    }
  } catch {}
  const reconcileDepositRecovery = cart => {
    const pending = window.__cpDrinkboxDepositRecoveryPending;
    if (!pending || !Array.isArray(cart?.items)) return;
    const lines = cart.items.filter(item => item.properties?._cpBoxId === pending.boxId);
    const deposits = lines.filter(item => item.properties?._cpLineType === 'drinkbox-deposit');
    const drinks = lines.filter(item => /^MIX-688782_JB9_[1-6]$/.test(String(item.properties?.['_easyBundle:OfferId'] || '')));
    if (lines.length !== 7 || deposits.length !== 1 || drinks.length !== 6 || drinks.some(item => Number(item.quantity) !== 1)) return;
    const offers = new Set(drinks.map(item => item.properties['_easyBundle:OfferId']));
    if (offers.size !== 6) return;
    const deposit = deposits[0];
    if (Number(deposit.quantity) !== 1 || Number(deposit.original_line_price ?? deposit.line_price) !== 150 || Number(deposit.final_line_price ?? deposit.line_price) !== 150) return;
    window.__cpDrinkboxDepositRecoveryPending = null;
    try { window.sessionStorage?.removeItem(depositRecoveryStorageKey); } catch {}
    document.dispatchEvent(new CustomEvent('cp:drinkbox-deposit-resolved', { detail: { source: 'owned-cart', boxId: pending.boxId } }));
  };
  let refreshing = null;
  let rerun = false;
  let mutation = null;
  let refreshTimer;
  let refreshFailed = false;
  let counterVersion = 0;
  let counterAuthority = 0;
  let counterRefreshing = null;
  let counterRerun = false;
  const drawer = () => document.querySelector('cart-drawer.cp-owned-cart');
  const hasPendingQuantity = () => [...(drawer()?.querySelectorAll('.quantity__input') || [])].some(input =>
    !input.disabled && !input.closest('[data-cp-protected], [data-cp-cart-fee="true"]') &&
    Number(input.value) !== Number(input.getAttribute('value')));
  const checkoutUnavailable = () => {
    const root = drawer();
    return !root || mutation || refreshing || refreshFailed || window.__cpDrinkboxDepositRecoveryPending || hasPendingQuantity() ||
      root.classList.contains('is-empty') || root.hasAttribute('data-cp-cart-busy') ||
      root.hasAttribute('data-cp-cart-error');
  };
  document.addEventListener('click', event => {
    const button = event.target?.closest?.('#CartDrawer-Checkout');
    if (button && (button.disabled || checkoutUnavailable())) event.preventDefault();
  }, true);
  document.addEventListener('change', event => {
    if (!event.target?.matches?.('cart-drawer.cp-owned-cart .quantity__input')) return;
    const button = drawer()?.querySelector('#CartDrawer-Checkout');
    if (button && hasPendingQuantity()) { button.disabled = true; button.setAttribute('aria-disabled', 'true'); button.tabIndex = -1; }
  }, true);
  const errorText = error => typeof error?.description === 'string' ? error.description : typeof error?.message === 'string' ? error.message : window.cartStrings?.error || 'Cart error';
  let feedback = null;
  let feedbackTimer = null;
  let feedbackSequence = 0;
  const feedbackLabels = () => {
    const german = document.documentElement.lang.toLowerCase().startsWith('de');
    const fallback = german ? {
      added: 'Im Warenkorb', view: 'Warenkorb ansehen', close: 'Bestätigung schließen',
      updated: 'Dein Warenkorb wurde aktualisiert.', errorTitle: 'Warenkorb prüfen',
      error: 'Warenkorb konnte nicht aktualisiert werden. Bitte prüfe ihn erneut.'
    } : {
      added: 'In your cart', view: 'View cart', close: 'Close confirmation',
      updated: 'Your cart has been updated.', errorTitle: 'Check your cart',
      error: 'Your cart could not be updated. Please check it again.'
    };
    try {
      const source = document.querySelector('[data-cp-cart-feedback-labels]');
      const labels = source ? JSON.parse(source.textContent) : window.cpCartFeedbackStrings;
      if (labels && typeof labels === 'object') {
        Object.keys(fallback).forEach(key => { if (typeof labels[key] === 'string' && labels[key].trim()) fallback[key] = labels[key]; });
      }
    } catch {}
    return fallback;
  };
  const hideFeedback = () => {
    clearTimeout(feedbackTimer);
    if (feedback) feedback.hidden = true;
  };
  const restartFeedbackTimer = () => {
    clearTimeout(feedbackTimer);
    if (!feedback || feedback.hidden || feedback.matches(':hover') || feedback.contains(document.activeElement) || feedback.dataset.error === 'true') return;
    feedbackTimer = setTimeout(hideFeedback, 6000);
  };
  const makeFeedback = () => {
    if (feedback?.isConnected) return feedback;
    const root = document.createElement('aside');
    root.id = 'cp-owned-feedback'; root.className = 'cp-owned-feedback'; root.hidden = true;
    const media = document.createElement('img');
    media.className = 'cp-owned-feedback__image'; media.width = 48; media.height = 54; media.alt = ''; media.hidden = true; media.decoding = 'sync'; media.loading = 'eager';
    const mediaWrap = document.createElement('span'); mediaWrap.className = 'cp-owned-feedback__media';
    const mediaFallback = document.createElement('span'); mediaFallback.className = 'cp-owned-feedback__fallback'; mediaFallback.textContent = '🛍️'; mediaFallback.setAttribute('aria-hidden', 'true');
    mediaWrap.append(media, mediaFallback);
    const copy = document.createElement('div');
    copy.className = 'cp-owned-feedback__copy'; copy.setAttribute('aria-live', 'polite'); copy.setAttribute('aria-atomic', 'true'); copy.setAttribute('role', 'status');
    const heading = document.createElement('strong'); heading.className = 'cp-owned-feedback__heading';
    const title = document.createElement('p'); title.className = 'cp-owned-feedback__title';
    const meta = document.createElement('p'); meta.className = 'cp-owned-feedback__meta'; meta.hidden = true; copy.append(heading, title, meta);
    const view = document.createElement('button'); view.type = 'button'; view.className = 'cp-owned-feedback__view';
    view.addEventListener('click', () => {
      hideFeedback();
      window.CandyPeakOwnedCart.open(document.getElementById('cart-icon-bubble')).catch(() => {});
    });
    const close = document.createElement('button'); close.type = 'button'; close.className = 'cp-owned-feedback__close'; close.textContent = '×';
    close.addEventListener('click', () => { hideFeedback(); if (document.activeElement === close) document.getElementById('cart-icon-bubble')?.focus(); });
    root.addEventListener('mouseenter', () => clearTimeout(feedbackTimer));
    root.addEventListener('mouseleave', restartFeedbackTimer);
    root.addEventListener('focusin', () => clearTimeout(feedbackTimer));
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) queueMicrotask(restartFeedbackTimer); });
    root.addEventListener('keydown', event => { if (event.key === 'Escape') { hideFeedback(); document.getElementById('cart-icon-bubble')?.focus(); } });
    root.append(mediaWrap, copy, view, close); document.body.append(root); feedback = root;
    return root;
  };
  const imageURL = (value, thumbnail = false) => {
    try {
      const url = new URL(value, location.origin);
      if (!value || !['https:', 'http:'].includes(url.protocol)) return '';
      if (thumbnail && (url.hostname === 'cdn.shopify.com' || url.origin === location.origin && url.pathname.startsWith('/cdn/shop/'))) {
        url.searchParams.set('width', '144');
        url.searchParams.delete('height');
      }
      return url.href;
    } catch { return ''; }
  };
  const captureFeedbackContext = (trigger, supplied = {}) => {
    const form = trigger?.closest?.('form');
    const card = trigger?.closest?.('.card-wrapper,.cp-tiktok__card,.cp-tiktok__product-card,.cpz__card,[data-mystery-card],.cp-owned-cart-recommendations__item,.product');
    const requested = imageURL(supplied.image);
    const candidates = [...(card?.querySelectorAll?.('img') || []), ...(document.images || [])];
    const cached = candidates.find(image => {
      if (!image.complete || !image.naturalWidth) return false;
      const current = imageURL(image.currentSrc || image.src);
      if (!requested) return card?.contains?.(image);
      if (current === requested) return true;
      try { const a = new URL(current); const b = new URL(requested); return a.origin === b.origin && a.pathname === b.pathname; } catch { return false; }
    });
    const image = cached ? imageURL(cached.currentSrc || cached.src) : imageURL(requested || card?.querySelector?.('img')?.src, true);
    const quantity = Number(supplied.quantity ?? form?.querySelector('[name="quantity"]')?.value ?? 1);
    return {
      title: typeof supplied.title === 'string' ? supplied.title : card?.querySelector?.('.card__heading,.cp-tiktok__product-title,.cpz__title,[data-cp-card-title],h1')?.textContent?.replace(/\s+/g, ' ').trim() || '',
      variantTitle: typeof supplied.variantTitle === 'string' && supplied.variantTitle !== 'Default Title' ? supplied.variantTitle : '',
      variantId: String(supplied.variantId || form?.querySelector('[name="id"]')?.value || trigger?.dataset?.variantId || trigger?.dataset?.id || ''),
      quantity: Number.isInteger(quantity) && quantity > 0 ? quantity : 1,
      image
    };
  };
  const feedbackItem = (payload, trigger, context = {}) => {
    const data = payload?.data && typeof payload.data === 'object' ? payload.data : payload;
    const variantID = context.variantId || trigger?.closest?.('form')?.querySelector('[name="id"]')?.value || trigger?.dataset?.variantId || trigger?.dataset?.id;
    let items = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : Array.isArray(data?.products) ? data.products : data?.item ? [data.item] : data?.product ? [data.product] : data?.cart?.items || [data];
    items = items.filter(item => item && typeof item === 'object' && !['deposit', 'drinkbox-deposit'].includes(item.properties?._cpLineType) && String(item.properties?._cpDrinkboxDeposit) !== 'true' && !/(?:^|[-\s])(?:pfand|deposit)(?:$|[-\s])/i.test(`${item.handle || ''} ${item.product_title || item.title || ''}`));
    const matched = variantID && items.find(item => String(item.variant_id || item.id) === String(variantID));
    const isFullCart = typeof data?.item_count === 'number' || data?.cart;
    // A full-cart response without a matching trigger cannot identify the added product reliably.
    const item = matched || (isFullCart && items.length > 1 ? null : items[0]);
    if (!item) return context;
    const image = item.image?.url || item.image?.src || (typeof item.image === 'string' ? item.image : '') || item.featured_image?.url || item.featured_image?.src || (typeof item.featured_image === 'string' ? item.featured_image : '') || item.images?.[0]?.src || item.images?.[0]?.url || (typeof item.images?.[0] === 'string' ? item.images[0] : '');
    const variantTitle = typeof item.variant_title === 'string' && item.variant_title !== 'Default Title' ? item.variant_title : context.variantTitle || '';
    return { title: typeof item.product_title === 'string' ? item.product_title : context.title || (typeof item.title === 'string' ? item.title : ''), image: context.image || imageURL(image, true), variantTitle, quantity: context.quantity || 1 };
  };
  const animatedAdditions = new WeakSet();
  const additionFeedback = new WeakMap();
  const pendingAddTriggers = new WeakMap();
  const visibleRect = element => {
    const rect = element?.getBoundingClientRect?.();
    if (!rect || rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 ||
        rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth) return null;
    return rect;
  };
  const rocketOrigin = trigger => {
    const source = trigger || document.activeElement;
    const card = source?.closest?.('.card-wrapper,.cp-tiktok__card,.cpz__card,[data-mystery-card]');
    const rect = visibleRect(source) || visibleRect(card?.querySelector('img'));
    return rect ? { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 } : { x: window.innerWidth / 2, y: window.innerHeight * .65 };
  };
  const rocketTarget = () => {
    const target = drawer()?.classList.contains('active')
      ? drawer().querySelector('.drawer__heading')
      : document.getElementById('cart-icon-bubble');
    return visibleRect(target) ? target : null;
  };
  const clearPendingTrigger = token => {
    const state = token && additionFeedback.get(token);
    if (state?.trigger && pendingAddTriggers.get(state.trigger) === token) {
      state.trigger.removeAttribute?.('data-cp-add-pending');
      pendingAddTriggers.delete(state.trigger);
    }
  };
  const showRocketImpact = state => {
    if (!state.confirmed || state.cancelled || document.hidden ||
        window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return;
    const rect = visibleRect(state.target);
    if (!rect) return;
    const ring = document.createElement('span');
    ring.className = 'cp-owned-cart-impact';
    ring.setAttribute('aria-hidden', 'true');
    ring.style.left = `${rect.left + rect.width / 2 - 21}px`;
    ring.style.top = `${rect.top + rect.height / 2 - 21}px`;
    document.body.appendChild(ring);
    ring.animate([
      { transform: 'scale(.65)', opacity: .65 },
      { transform: 'scale(1.4)', opacity: 0 }
    ], { duration: 200, easing: 'ease-out', fill: 'forwards' }).finished.catch(() => {}).finally(() => ring.remove());
    window.setTimeout(() => ring.remove(), 500);
  };
  const cancelAddFeedback = token => {
    const state = token && additionFeedback.get(token);
    clearPendingTrigger(token);
    if (!state || state.confirmed || state.cancelled) return;
    state.cancelled = true;
    clearTimeout(state.timer);
    state.animation?.cancel();
    state.rocket?.remove();
  };
  const beginAddFeedback = (trigger, capturedOrigin, context) => {
    const token = {};
    const origin = capturedOrigin || rocketOrigin(trigger);
    const state = { origin, trigger, context: captureFeedbackContext(trigger, context), rocket: null, animation: null, timer: null, confirmed: false, cancelled: false, finished: false };
    additionFeedback.set(token, state);
    if (trigger) {
      pendingAddTriggers.set(trigger, token);
      trigger.setAttribute?.('data-cp-add-pending', '');
    }
    if (state.context.image) {
      state.thumbnail = document.createElement('img');
      state.thumbnail.decoding = 'async'; state.thumbnail.loading = 'eager'; state.thumbnail.src = state.context.image;
      state.thumbnail.decode?.().catch(() => {});
    }
    const target = rocketTarget();
    if (!origin || !target || document.hidden ||
        window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ||
        typeof target.animate !== 'function') return token;
    const size = 42;
    const startX = Math.max(size / 2, Math.min(window.innerWidth - size / 2, origin.x));
    const startY = Math.max(size / 2, Math.min(window.innerHeight - size / 2, origin.y));
    const rect = visibleRect(target);
    const deltaX = rect.left + rect.width / 2 - startX;
    const deltaY = rect.top + rect.height / 2 - startY;
    const rocket = document.createElement('span');
    rocket.className = 'cp-owned-cart-rocket';
    rocket.textContent = '🚀';
    rocket.setAttribute('aria-hidden', 'true');
    rocket.style.left = `${startX - size / 2}px`;
    rocket.style.top = `${startY - size / 2}px`;
    document.body.appendChild(rocket);
    state.rocket = rocket;
    state.target = target;
    state.animation = rocket.animate([
      { transform: 'translate3d(0,8px,0) scale(.65) rotate(-18deg)', opacity: 0 },
      { offset: .12, transform: `translate3d(${deltaX * .07}px,${deltaY * .1 - 16}px,0) scale(1) rotate(-12deg)`, opacity: 1 },
      { offset: .62, transform: `translate3d(${deltaX * .58}px,${deltaY * .7 - 28}px,0) scale(.75) rotate(10deg)`, opacity: 1 },
      { transform: `translate3d(${deltaX}px,${deltaY}px,0) scale(.12) rotate(28deg)`, opacity: 0 }
    ], { duration: 700, easing: 'cubic-bezier(.22,.55,.35,1)', fill: 'forwards' });
    state.animation.finished.then(() => {
      state.finished = true;
      showRocketImpact(state);
    }).catch(() => {}).finally(() => { clearTimeout(state.timer); rocket.remove(); state.rocket = null; });
    state.timer = setTimeout(() => {
      state.animation?.cancel();
      state.rocket?.remove();
      state.rocket = null;
      state.finished = true;
    }, 1000);
    return token;
  };
  const launchCartRocket = (payload, origin, feedbackToken) => {
    const data = payload?.data && typeof payload.data === 'object' ? payload.data : payload;
    if (!data || typeof data !== 'object' || data.errors || data.status >= 400 || animatedAdditions.has(data)) {
      cancelAddFeedback(feedbackToken);
      return false;
    }
    animatedAdditions.add(data);
    const token = feedbackToken || beginAddFeedback(null, origin);
    const state = additionFeedback.get(token);
    clearPendingTrigger(token);
    if (state && !state.cancelled) state.confirmed = true;
    return true;
  };
  const successfulAddFeedback = (result, trigger, origin, showConfirmation = true, feedbackToken) => {
    const data = result?.data && typeof result.data === 'object' ? result.data : result;
    if (!data || typeof data !== 'object' || data.errors || data.status >= 400 || animatedAdditions.has(data)) {
      cancelAddFeedback(feedbackToken);
      return;
    }
    const context = feedbackToken && additionFeedback.get(feedbackToken)?.context || captureFeedbackContext(trigger);
    refreshCounter().catch(() => {});
    if (showConfirmation) showFeedback(result, trigger, undefined, context);
    try { launchCartRocket(result, origin, feedbackToken); } catch { cancelAddFeedback(feedbackToken); }
  };
  const showFeedback = (payload, trigger, errorMessage, context) => {
    if (drawer()?.classList.contains('active')) { hideFeedback(); return; }
    const root = makeFeedback(); const labels = feedbackLabels(); const item = feedbackItem(payload, trigger, context);
    root.dataset.error = String(Boolean(errorMessage));
    const copy = root.querySelector('.cp-owned-feedback__copy');
    copy.setAttribute('role', errorMessage ? 'alert' : 'status'); copy.setAttribute('aria-live', errorMessage ? 'assertive' : 'polite');
    root.querySelector('.cp-owned-feedback__heading').textContent = errorMessage ? labels.errorTitle : labels.added;
    root.querySelector('.cp-owned-feedback__title').textContent = errorMessage || item.title || labels.updated;
    const meta = root.querySelector('.cp-owned-feedback__meta');
    meta.hidden = Boolean(errorMessage);
    meta.textContent = item.variantTitle ? `${item.quantity || 1} × ${item.variantTitle}` : `${document.documentElement.lang.toLowerCase().startsWith('de') ? 'Menge' : 'Quantity'}: ${item.quantity || 1}`;
    root.querySelector('.cp-owned-feedback__view').textContent = labels.view;
    root.querySelector('.cp-owned-feedback__close').setAttribute('aria-label', labels.close);
    const image = root.querySelector('img');
    const placeholder = root.querySelector('.cp-owned-feedback__fallback');
    const source = !errorMessage && imageURL(item.image);
    image.onload = () => {
      if (imageURL(image.getAttribute('src')) !== source || !image.complete || !image.naturalWidth || imageURL(image.currentSrc || image.src) !== source) return;
      image.hidden = false; placeholder.hidden = true; root.classList.remove('cp-owned-feedback--no-image');
    };
    image.onerror = () => {
      if (imageURL(image.getAttribute('src')) !== source) return;
      image.hidden = true; placeholder.hidden = false; root.classList.add('cp-owned-feedback--no-image');
    };
    if (source) {
      if (imageURL(image.getAttribute('src')) !== source) image.src = source;
      const ready = Boolean(image.complete && image.naturalWidth && imageURL(image.currentSrc || image.src) === source);
      image.hidden = !ready; placeholder.hidden = ready;
    } else {
      image.hidden = true; placeholder.hidden = false;
    }
    root.classList.toggle('cp-owned-feedback--no-image', !source);
    root.hidden = false; restartFeedbackTimer();
  };
  const showError = error => {
    const target = document.getElementById('CartDrawer-CartErrors');
    if (target) { target.textContent = errorText(error); target.setAttribute('role', 'alert'); }
    if (!drawer()?.classList.contains('active')) showFeedback(null, null, typeof error?.description === 'string' ? error.description : feedbackLabels().error);
  };
  document.addEventListener('cp:cart:opened', hideFeedback);
  const getJSON = async (url, options) => {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw Object.assign(new Error(typeof data.errors === 'string' ? data.errors : errorText(data)), data);
    return data;
  };
  const post = (path, data) => getJSON(base + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
  const readCart = () => getJSON(base + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
  const renderCounter = sections => {
    const bubble = document.getElementById('cart-icon-bubble');
    const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
    const content = parsed.querySelector('.shopify-section');
    if (bubble && content && bubble.innerHTML !== content.innerHTML) bubble.innerHTML = content.innerHTML;
  };
  const refreshCounter = () => {
    ++counterVersion;
    if (counterRefreshing) { counterRerun = true; return counterRefreshing; }
    counterRefreshing = (async () => {
      do {
        counterRerun = false;
        const version = counterVersion;
        const authority = counterAuthority;
        const url = new URL(base, location.origin);
        url.searchParams.set('sections', 'cart-icon-bubble');
        const sections = await getJSON(url.toString(), { cache: 'no-store' });
        if (version === counterVersion && authority === counterAuthority) renderCounter(sections);
      } while (counterRerun);
    })().finally(() => { counterRefreshing = null; });
    return counterRefreshing;
  };
  const protectedItem = item => Boolean(/^MIX-688782_JB9_[1-6]$/.test(String(item?.properties?.['_easyBundle:OfferId'] || '')) || ['deposit', 'drinkbox-deposit'].includes(item?.properties?._cpLineType) || String(item?.properties?._cpDrinkboxDeposit) === 'true' || ['pfand', 'drinkbox-pfand'].includes(item?.handle) || item?.handle === 'fees' && item?.product_title === 'Pfand');
  const setBusy = busy => {
    const root = drawer(); if (!root) return;
    root.toggleAttribute('data-cp-cart-busy', busy);
    root.toggleAttribute('data-cp-cart-error', refreshFailed);
    root.toggleAttribute('data-cp-cart-deposit-error', Boolean(window.__cpDrinkboxDepositRecoveryPending));
    root.setAttribute('aria-busy', String(busy));
    root.querySelectorAll('.quantity__button,.quantity__input,cart-remove-button button,[data-cp-remove-mix],button.cp-owned-cart-recommendations__action').forEach(control => { control.disabled = busy || refreshFailed || control.hasAttribute('data-cp-needs-choice') || Boolean(control.closest('[data-cp-protected]')); });
    const checkout = root.querySelector('#CartDrawer-Checkout');
    if (checkout) {
      const unavailable = busy || refreshFailed || Boolean(window.__cpDrinkboxDepositRecoveryPending) || hasPendingQuantity() || root.classList.contains('is-empty');
      checkout.disabled = unavailable;
      checkout.toggleAttribute('disabled', unavailable);
      checkout.setAttribute('aria-disabled', String(unavailable));
      checkout.tabIndex = unavailable ? -1 : 0;
    }
  };
  // Refresh never opens the drawer; only an explicit open() action may do that.
  const refresh = () => {
    if (refreshing) { rerun = true; return refreshing; }
    clearTimeout(refreshTimer);
    setBusy(true);
    refreshing = (async () => {
      do {
        rerun = false;
        const counterRevision = counterVersion;
        const root = drawer(); if (!root) return;
        const url = new URL(base, location.origin);
        url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
        const sections = await getJSON(url.toString(), { cache: 'no-store' });
        if (counterRevision !== counterVersion) { rerun = true; continue; }
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
        const incoming = parsed.querySelector('#CartDrawer');
        const current = root.querySelector('#CartDrawer');
        if (!incoming || !current) throw new Error(window.cartStrings?.error || 'Cart error');
        let cart;
        try { cart = JSON.parse(incoming.querySelector('[data-cp-owned-cart-state]').textContent); } catch {}
        if (!Array.isArray(cart?.items) || !Number.isInteger(cart.item_count)) cart = await readCart();
        reconcileDepositRecovery(cart);
        const active = document.activeElement;
        const focusKey = active?.closest('[data-line-key]')?.dataset.lineKey;
        const focusName = active?.getAttribute('name');
        current.innerHTML = incoming.innerHTML;
        refreshFailed = false;
        if (feedback?.dataset.error === 'true') hideFeedback();
        root.classList.toggle('is-empty', !cart.item_count);
        ++counterAuthority;
        renderCounter(sections);
        if (root.contains(active) || focusKey) {
          const row = [...root.querySelectorAll('[data-line-key]')].find(node => node.dataset.lineKey === focusKey);
          const target = row ? [...row.querySelectorAll('[name]')].find(node => node.getAttribute('name') === focusName) : null;
          root.restoreFocus(target);
        } else if (root.classList.contains('active')) root.restoreFocus();
        document.dispatchEvent(new CustomEvent('cp:cart:updated', { detail: { cart } }));
      } while (rerun);
    })().catch(error => { refreshFailed = true; showError(error); throw error; }).finally(() => { refreshing = null; setBusy(Boolean(mutation)); });
    return refreshing;
  };
  const runMutation = (work, button, open) => {
    if (mutation) {
      if (button) button.disabled = true;
      return mutation.catch(() => {}).then(() => runMutation(work, button, open));
    }
    if (button) button.disabled = true;
    setBusy(true);
    mutation = (async () => {
      try {
        const result = await work();
        try { await refresh(); } catch {}
        return result;
      } catch (error) {
        try { await refresh(); } catch {}
        showError(error);
        throw error;
      }
      finally { setBusy(false); if (button?.isConnected) button.disabled = false; mutation = null; }
    })();
    return mutation;
  };
  const confirmAdd = async (result, trigger, capturedOrigin, feedbackToken) => {
    const data = result?.data && typeof result.data === 'object' ? result.data : result;
    if (!data || typeof data !== 'object' || data.errors || data.status >= 400) {
      cancelAddFeedback(feedbackToken);
      throw Object.assign(new Error(errorText(data)), data);
    }
    const sequence = ++feedbackSequence;
    const origin = capturedOrigin || rocketOrigin(trigger);
    drawer()?.setActiveElement(trigger || document.activeElement);
    successfulAddFeedback(result, trigger, origin, sequence === feedbackSequence, feedbackToken);
    refresh().catch(() => {});
    return result;
  };
  const addItem = (item, button, feedbackToken) => {
    const origin = rocketOrigin(button);
    const pendingFeedback = feedbackToken || beginAddFeedback(button, origin, { variantId: item.id, quantity: item.quantity || 1 });
    drawer()?.setActiveElement(button || document.activeElement);
    return runMutation(async () => {
      const result = await post('cart/add.js', { items: [item] });
      successfulAddFeedback(result, button, origin, true, pendingFeedback);
      return result;
    }, button, false).catch(error => { cancelAddFeedback(pendingFeedback); throw error; });
  };
  const changeItem = (key, quantity) => runMutation(async () => {
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error(window.cartStrings?.error || 'Cart error');
    const cart = await readCart();
    const item = cart.items.find(line => line.key === key);
    if (!item || protectedItem(item)) return;
    return post('cart/change.js', { id: key, quantity });
  }, null, false).catch(() => {});
  const removeMixBoxes = button => runMutation(async () => {
    const cart = await readCart();
    const updates = {};
    cart.items.forEach(item => {
      const offer = String(item.properties?.['_easyBundle:OfferId'] || '');
      if (/^MIX-688782_JB9_[1-6]$/.test(offer) || item.properties?._cpLineType === 'drinkbox-deposit' || String(item.properties?._cpDrinkboxDeposit) === 'true') updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    return post('cart/update.js', { updates });
  }, button, false);
  const open = async trigger => {
    ++feedbackSequence;
    hideFeedback();
    drawer()?.open(trigger || document.activeElement);
    setBusy(true);
    try { await refresh(); }
    finally { setBusy(Boolean(mutation)); }
  };
  window.CandyPeakOwnedCart = { addItem, confirmAdd, beginAddFeedback, cancelAddFeedback, captureAddOrigin: rocketOrigin, changeItem, removeMixBoxes, refresh, open, close: () => drawer()?.close() };
  const schedule = () => { clearTimeout(refreshTimer); refreshTimer = setTimeout(() => refresh().catch(() => {}), 160); };
  ['cart:refresh', 'cart:updated', 'cart:change', 'fg-cart:auto-updated', 'fg-gifts:updated', 'fg-gifts:added'].forEach(name => { document.addEventListener(name, schedule); window.addEventListener(name, schedule); });
  document.addEventListener('fg-cart:end-process', () => {
    setBusy(true);
    refresh().catch(() => {});
  });
  document.addEventListener('cp:drinkbox-deposit-pending', () => {
    setBusy(Boolean(mutation) || Boolean(refreshing));
    showError(new Error(window.__cpDrinkboxDepositRecoveryPending?.message || feedbackLabels().error));
  });
  document.addEventListener('cp:drinkbox-deposit-resolved', event => {
    setBusy(Boolean(mutation) || Boolean(refreshing));
    if (event.detail?.source !== 'owned-cart') refresh().catch(() => {});
  });
  if (window.__cpDrinkboxDepositRecoveryPending) setBusy(false);
})();



